import PropTypes from 'prop-types'
import ImageAsync from '../../components/native/ImageAsync'
import { SliderContainer } from '../../components/swipper/SliderContainer'

const SpotsGallery = ({ images = [] }) => {
    
    if(images.length < 1) {
        return <h1 className='text-center'>Galeria vacia</h1>;
    }

    return (
        <div>

            <SliderContainer currentSlide={()=>{}}>

                {
                    images.map((image, index) => {
                        return (<ImageAsync key={'spi_' + (index + 1)} className="image-spot-gallery" src={image.imageUrl} alt={"Elemento " + (index + 1)} />)
                    })
                }


            </SliderContainer>

        </div>
    )
}

SpotsGallery.propTypes = {
    images: PropTypes.array
}

export default SpotsGallery